import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {
    /**
     * Return BLOB contents from specified url.
     * @param {String} url
     */
    apiGetBlobContent: function(url) {
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
}
